import * as React from 'react';

import { WithChildrenCommonProps } from '@types';

import useResponsiveFontSize, {
  IuseResponsiveFontSizeProps,
} from './use-responsive-font-size';

export const ResponsiveFontSize: React.FC<
  WithChildrenCommonProps<IuseResponsiveFontSizeProps>
> = ({ children, ratio, optionsObject }) => {
  const ref = useResponsiveFontSize(ratio, optionsObject);

  return (
    <div ref={ref} style={{ width: '100%', height: '100%' }}>
      {children}
    </div>
  );
};
